<template>
  <div class="charts-page">

    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel
          class="chart-widget"
          :title="tituloPagina"
          :footerText="rodapePagina"
          :footerComplementar="rodapeComplementarPagina"
          :tooltipOptions="tooltipOptions"
          :noPadding="iframeOcuparPainelCompleto">
          <iframePowerBI :fonte='fonte' @token-refresh="buscarLinkBi"> </iframePowerBI>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'
import iframePowerBI from '@/components/iframe/implementacoes/iframePowerBI'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'

export default {
  name: 'dashboard-iframe-powerbi',
  components: {
    iframePowerBI,
    Sp360Panel,
  },
  props: ['chaveIframe'],
  data: () => ({
    fonte: {},
    fonteDados: "",
    dataDados: "",
    tituloPagina: "",
    rodapePagina: "",
    rodapeComplementarPagina: "",
    tooltipOptions: null,
    iframeOcuparPainelCompleto: false
  }),
  mounted () {
    this.buscarLinkBi()
  },
  methods: {
    buscarLinkBi () {
      this.$store.dispatch('iframeDashboard/buscarUrlIframe', { nome: this.chaveIframe })
        .then((retorno) => {
          this.fonte = retorno.data
          this.configurarDashboard()
        }).catch((error) => {
          console.error(error)
        })
    },
    configurarDashboard() {
      if(this.fonte.iframeEmbeddingConfig &&
         this.fonte.iframeEmbeddingConfig.iframeOcuparPainelCompleto) {
        this.iframeOcuparPainelCompleto = true
        return
      }
      if(!MetodosGlobais.isTextoVazio(this.fonte.titulo))
        this.tituloPagina = this.$t(this.fonte.titulo)
      if(!MetodosGlobais.isTextoVazio(this.fonte.nomeFonte))
        this.rodapePagina = "Fonte: " + this.fonte.nomeFonte
      if(!MetodosGlobais.isTextoVazio(this.fonte.rodapeComplementar))
        this.rodapeComplementarPagina = this.$t(this.fonte.rodapeComplementar)
      if(!MetodosGlobais.isTextoVazio(this.fonte.conteudoTooltip))
        this.tooltipOptions = {content: this.$t(this.fonte.conteudoTooltip), placement: !MetodosGlobais.isTextoVazio(this.fonte.posicaoTooltip) ? this.fonte.posicaoTooltip : 'bottom'}
    }
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}
</style>
